import { JSX } from 'react'

import { IconProps } from '../../icon'

const TIC: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 31 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_1081_251)'>
      <path
        d='M25.7974 5.84927L5.8863 7.82225C5.41919 7.87105 4.94512 7.81528 4.8266 7.7107L0.246208 3.48587C0.239236 3.1094 0.350783 2.91419 1.02704 2.85144L29.6179 0.0139709C30.2941 -0.0557459 30.6636 0.076716 30.7264 0.348611L26.8083 5.5216C26.7177 5.66103 26.2645 5.80046 25.7974 5.84927Z'
        fill='white'
      />
      <path
        d='M30.7403 0.585625L27.0523 5.80044C27.0244 5.84227 26.9617 5.8841 26.8711 5.91896C26.6758 6.00959 26.3551 6.08628 26.0275 6.12114L6.01876 8.10109C5.8863 8.11504 5.75384 8.12201 5.62835 8.11504C5.30765 8.10807 5.03576 8.05926 4.9521 7.98258L0.315933 3.59739C0.281074 3.56253 0.260159 3.52767 0.253187 3.49281L0.246216 3.48584C0.218329 3.30458 0.559941 3.13726 1.11768 3.08149L29.841 0.237042C30.5242 0.167325 30.9216 0.327673 30.7403 0.585625Z'
        fill='#232420'
      />
      <path
        d='M27.4428 20.0018L7.35735 21.9887C6.90419 22.0305 6.49983 21.7029 6.458 21.2497L5.24493 9.00743C5.2031 8.55427 5.53077 8.14991 5.98393 8.10808L26.0693 6.12115C26.5225 6.07932 26.9268 6.40699 26.9687 6.86015L28.1748 19.1024C28.2236 19.5486 27.8889 19.953 27.4428 20.0018Z'
        fill='#F6F6F6'
      />
      <path
        d='M26.0414 5.84229L5.82354 7.84316L1.71722 3.61135L29.1926 0.892395L26.0414 5.84229Z'
        fill='white'
      />
      <path
        d='M28.9207 1.31767L2.07278 3.97388L1.71722 3.61135L29.1926 0.892395L28.9207 1.31767Z'
        fill='#F8C550'
      />
      <path
        d='M26.0414 5.84232L5.82358 7.84319L5.6214 7.64102L26.1948 5.60529L26.0414 5.84232Z'
        fill='#F8C550'
      />
      <path
        d='M20.2968 2.69112L10.8013 3.6323L10.7107 3.41618L20.3386 2.46106L20.2968 2.69112Z'
        fill='#9C9B98'
      />
      <path
        d='M26.153 2.475L5.26582 4.54559L5.10547 4.34341L26.2715 2.24493L26.153 2.475Z'
        fill='#9C9B98'
      />
      <path
        d='M10.7944 5.64012L6.47192 6.0654L5.44708 4.77564L10.1809 4.30853L10.7944 5.64012Z'
        fill='#29B8E2'
      />
      <path
        opacity='0.36'
        d='M11.3939 6.92987L7.46886 7.32028L6.63226 6.26059L10.892 5.84229L11.3939 6.92987Z'
        fill='#29B8E2'
      />
      <path
        opacity='0.36'
        d='M25.7695 3.21394L10.8989 4.68497L10.7177 4.25272L26.0205 2.73987L25.7695 3.21394Z'
        fill='#29B8E2'
      />
      <path
        opacity='0.36'
        d='M25.4488 3.83448L11.1429 5.24973L10.9686 4.84537L25.6789 3.39526L25.4488 3.83448Z'
        fill='#29B8E2'
      />
      <path
        opacity='0.19'
        d='M24.9399 4.81748L11.5194 6.14907L11.373 5.79351L25.142 4.42706L24.9399 4.81748Z'
        fill='#29B8E2'
      />
      <path
        opacity='0.19'
        d='M24.6819 5.32639L11.7216 6.60918L11.5752 6.27454L24.8702 4.96387L24.6819 5.32639Z'
        fill='#29B8E2'
      />
      <path
        d='M25.9647 15.6166L8.16604 17.3804C7.80351 17.4153 7.48281 17.1504 7.44796 16.7878L6.79959 10.2972C6.76473 9.93467 7.02966 9.61397 7.39218 9.57911L25.1909 7.81528C25.5534 7.78042 25.8741 8.04534 25.909 8.40787L26.5504 14.8985C26.5852 15.2541 26.3203 15.5817 25.9647 15.6166Z'
        fill='#F2F1F1'
      />
      <path
        d='M24.1244 6.30808L8.41785 7.86285L8.50575 8.75086L24.2123 7.19609L24.1244 6.30808Z'
        fill='#040400'
      />
      <path
        d='M19.2231 20.3294L15.7024 20.678C15.305 20.7198 14.9495 20.427 14.9076 20.0296L14.6985 17.8893C14.6567 17.492 14.9495 17.1364 15.3469 17.0946L18.8676 16.746C19.2649 16.7042 19.6205 16.997 19.6623 17.3944L19.8715 19.5347C19.9063 19.932 19.6205 20.2876 19.2231 20.3294Z'
        fill='#F2F1F1'
      />
      <path
        d='M9.00677 9.88852L7.64008 10.0238L7.67991 10.4262L9.0466 10.2909L9.00677 9.88852Z'
        fill='#232420'
      />
      <path
        d='M10.7917 9.71445L9.42505 9.84973L9.46488 10.2521L10.8316 10.1168L10.7917 9.71445Z'
        fill='#232420'
      />
      <path
        d='M12.5829 9.53269L11.2162 9.66797L11.2561 10.0703L12.6228 9.93506L12.5829 9.53269Z'
        fill='#232420'
      />
      <path
        d='M14.3679 9.35861L13.0012 9.4939L13.041 9.89627L14.4077 9.76099L14.3679 9.35861Z'
        fill='#232420'
      />
      <path
        d='M16.1528 9.18448L14.7861 9.31976L14.826 9.72214L16.1927 9.58686L16.1528 9.18448Z'
        fill='#232420'
      />
      <path
        d='M17.9371 9.00345L16.5704 9.13873L16.6102 9.54111L17.9769 9.40582L17.9371 9.00345Z'
        fill='#232420'
      />
      <path
        d='M19.7289 8.82864L18.3622 8.96393L18.4021 9.3663L19.7688 9.23101L19.7289 8.82864Z'
        fill='#232420'
      />
      <path
        d='M21.5132 8.64761L20.1465 8.7829L20.1864 9.18527L21.5531 9.04998L21.5132 8.64761Z'
        fill='#232420'
      />
      <path
        d='M23.2981 8.47347L21.9315 8.60876L21.9713 9.01114L23.338 8.87585L23.2981 8.47347Z'
        fill='#232420'
      />
      <path
        d='M25.09 8.29873L23.7233 8.43402L23.7632 8.8364L25.1299 8.70111L25.09 8.29873Z'
        fill='#232420'
      />
      <path
        d='M9.00907 10.4927L7.69788 10.6225L7.80432 11.6978L9.11551 11.568L9.00907 10.4927Z'
        fill='#232420'
      />
      <path
        d='M10.7236 10.3186L9.41241 10.4484L9.51886 11.5237L10.8301 11.3939L10.7236 10.3186Z'
        fill='#232420'
      />
      <path
        d='M12.4458 10.1508L11.1346 10.2806L11.241 11.3559L12.5522 11.2261L12.4458 10.1508Z'
        fill='#232420'
      />
      <path
        d='M14.161 9.98361L12.8499 10.1134L12.9563 11.1887L14.2675 11.0589L14.161 9.98361Z'
        fill='#232420'
      />
      <path
        d='M15.8756 9.80953L14.5644 9.93933L14.6708 11.0146L15.982 10.8848L15.8756 9.80953Z'
        fill='#232420'
      />
      <path
        d='M17.5908 9.64236L16.2796 9.77216L16.386 10.8475L17.6972 10.7177L17.5908 9.64236Z'
        fill='#232420'
      />
      <path
        d='M19.3123 9.46755L18.0011 9.59735L18.1075 10.6727L19.4187 10.5429L19.3123 9.46755Z'
        fill='#232420'
      />
      <path
        d='M21.0276 9.30044L19.7164 9.43024L19.8228 10.5056L21.134 10.3758L21.0276 9.30044Z'
        fill='#232420'
      />
      <path
        d='M22.7428 9.13327L21.4316 9.26306L21.538 10.3384L22.8492 10.2086L22.7428 9.13327Z'
        fill='#232420'
      />
      <path
        d='M25.1324 8.89759L23.1483 9.09399L23.2547 10.1693L25.2388 9.9729L25.1324 8.89759Z'
        fill='#232420'
      />
      <path
        d='M11.5182 11.5242L10.207 11.654L10.3134 12.7293L11.6246 12.5995L11.5182 11.5242Z'
        fill='#232420'
      />
      <path
        d='M13.2334 11.3571L11.9222 11.4869L12.0286 12.5622L13.3398 12.4324L13.2334 11.3571Z'
        fill='#232420'
      />
      <path
        d='M14.9486 11.1899L13.6375 11.3197L13.7439 12.395L15.0551 12.2652L14.9486 11.1899Z'
        fill='#232420'
      />
      <path
        d='M16.6701 11.0151L15.3589 11.1449L15.4654 12.2202L16.7766 12.0904L16.6701 11.0151Z'
        fill='#232420'
      />
      <path
        d='M18.3853 10.848L17.0742 10.9778L17.1806 12.0531L18.4918 11.9233L18.3853 10.848Z'
        fill='#232420'
      />
      <path
        d='M20.1006 10.6808L18.7894 10.8106L18.8959 11.8859L20.2071 11.7561L20.1006 10.6808Z'
        fill='#232420'
      />
      <path
        d='M21.8152 10.5067L20.504 10.6365L20.6104 11.7119L21.9216 11.5821L21.8152 10.5067Z'
        fill='#232420'
      />
      <path
        d='M23.5373 10.3389L22.2261 10.4687L22.3326 11.544L23.6438 11.4142L23.5373 10.3389Z'
        fill='#232420'
      />
      <path
        d='M25.2519 10.1648L23.9407 10.2946L24.0471 11.3699L25.3583 11.2401L25.2519 10.1648Z'
        fill='#232420'
      />
      <path
        d='M12.3061 12.7649L10.9949 12.8947L11.1014 13.97L12.4126 13.8402L12.3061 12.7649Z'
        fill='#232420'
      />
      <path
        d='M14.0213 12.5977L12.7101 12.7275L12.8166 13.8029L14.1278 13.6731L14.0213 12.5977Z'
        fill='#232420'
      />
      <path
        d='M15.7359 12.4237L14.4247 12.5535L14.5311 13.6288L15.8423 13.499L15.7359 12.4237Z'
        fill='#232420'
      />
      <path
        d='M17.4511 12.2565L16.14 12.3863L16.2464 13.4616L17.5576 13.3318L17.4511 12.2565Z'
        fill='#232420'
      />
      <path
        d='M19.1733 12.0887L17.8621 12.2184L17.9686 13.2938L19.2798 13.164L19.1733 12.0887Z'
        fill='#232420'
      />
      <path
        d='M20.8879 11.9146L19.5767 12.0444L19.6831 13.1197L20.9943 12.9899L20.8879 11.9146Z'
        fill='#232420'
      />
      <path
        d='M22.6031 11.7474L21.2919 11.8772L21.3984 12.9525L22.7096 12.8227L22.6031 11.7474Z'
        fill='#232420'
      />
      <path
        d='M25.382 11.4717L23.0094 11.7065L23.1158 12.7819L25.4885 12.547L25.382 11.4717Z'
        fill='#232420'
      />
      <path
        d='M13.0868 14.0133L11.7756 14.1431L11.882 15.2184L13.1932 15.0887L13.0868 14.0133Z'
        fill='#232420'
      />
      <path
        d='M14.8089 13.8455L13.4977 13.9753L13.6042 15.0506L14.9154 14.9208L14.8089 13.8455Z'
        fill='#232420'
      />
      <path
        d='M16.5241 13.6783L15.213 13.8081L15.3194 14.8834L16.6306 14.7536L16.5241 13.6783Z'
        fill='#232420'
      />
      <path
        d='M18.2387 13.5042L16.9276 13.634L17.034 14.7093L18.3452 14.5796L18.2387 13.5042Z'
        fill='#232420'
      />
      <path
        d='M19.954 13.3371L18.6428 13.4669L18.7492 14.5422L20.0604 14.4124L19.954 13.3371Z'
        fill='#232420'
      />
      <path
        d='M21.6761 13.1692L20.3649 13.299L20.4714 14.3743L21.7826 14.2445L21.6761 13.1692Z'
        fill='#232420'
      />
      <path
        d='M25.5328 12.7844L22.0779 13.1264L22.1843 14.2017L25.6392 13.8597L25.5328 12.7844Z'
        fill='#232420'
      />
      <path
        d='M11.3444 15.4839L10.0332 15.6137L10.1397 16.689L11.4508 16.5592L11.3444 15.4839Z'
        fill='#232420'
      />
      <path
        d='M18.3656 14.7892L11.7473 15.4444L11.8537 16.5197L18.4721 15.8646L18.3656 14.7892Z'
        fill='#232420'
      />
      <path
        d='M19.9261 14.6336L18.6149 14.7634L18.7214 15.8387L20.0326 15.7089L19.9261 14.6336Z'
        fill='#232420'
      />
      <path
        d='M21.5505 14.473L20.2393 14.6028L20.3458 15.6781L21.657 15.5483L21.5505 14.473Z'
        fill='#232420'
      />
      <path
        d='M24.3391 14.1937L23.1458 14.3118L23.2523 15.3871L24.4455 15.269L24.3391 14.1937Z'
        fill='#232420'
      />
      <path
        d='M23.0971 14.8611L21.9038 14.9792L21.9567 15.5134L23.1499 15.3953L23.0971 14.8611Z'
        fill='#232420'
      />
      <path
        d='M25.7045 14.6036L24.5112 14.7217L24.5641 15.2559L25.7574 15.1378L25.7045 14.6036Z'
        fill='#232420'
      />
      <path
        d='M9.88533 11.6892L7.82489 11.8932L7.93133 12.9685L9.99177 12.7645L9.88533 11.6892Z'
        fill='#232420'
      />
      <path
        d='M10.63 12.9346L7.95215 13.1997L8.05859 14.275L10.7365 14.0099L10.63 12.9346Z'
        fill='#232420'
      />
      <path
        d='M11.4163 14.1847L8.08624 14.5143L8.19269 15.5897L11.5227 15.26L11.4163 14.1847Z'
        fill='#232420'
      />
      <path
        d='M9.68432 15.6432L8.21356 15.7888L8.32 16.8641L9.79076 16.7185L9.68432 15.6432Z'
        fill='#232420'
      />
      <path
        d='M25.672 31.9582C26.2994 31.9025 26.9199 31.8327 27.5334 31.7351C27.1151 27.4336 26.4877 24.8123 26.4877 24.8123L24.3125 25.0214C24.3125 25.0214 24.8145 27.9356 25.163 32.0001C25.3373 31.9861 25.5047 31.9722 25.672 31.9582Z'
        fill='#ED6F3D'
      />
      <path
        d='M26.8501 23.2226L26.7246 20.9917C26.7246 20.9847 26.7246 20.9708 26.7246 20.9638L26.5155 18.7608C26.5015 18.5865 26.3412 18.454 26.1599 18.468C25.9787 18.4819 25.8462 18.6423 25.8671 18.8235L25.9159 20.3085H25.9089L25.5604 17.5756C25.5394 17.3804 25.3651 17.234 25.1699 17.2549H25.163C24.9678 17.2758 24.8283 17.4501 24.8423 17.6453L24.9678 20.3433H24.9538L24.5634 17.1921C24.5425 16.9969 24.3752 16.8575 24.18 16.8784C23.9917 16.8993 23.8453 17.0667 23.8662 17.2619L24.0754 20.3782H24.0475L23.7407 18.0357C23.7198 17.8405 23.5455 17.7011 23.3503 17.715H23.3364C23.1412 17.7359 23.0017 17.9102 23.0157 18.1054L23.3155 21.2915L23.3364 21.5355L23.3434 21.6261L22.9808 20.5734C22.9181 20.3852 22.7159 20.2876 22.5277 20.3573H22.5207C22.4092 20.3921 22.3325 20.4828 22.2976 20.5873C22.2767 20.6571 22.2767 20.7338 22.2976 20.8104C22.2976 20.8104 22.3255 20.8871 22.3604 21.0196C22.5277 21.5425 22.9669 22.888 23.1412 23.2645C23.3643 23.7316 23.7407 24.3381 24.2078 24.2057L24.2288 24.1917H24.2357V24.2057L24.3124 25.0213L26.4876 24.8122L26.4109 23.9756C26.7246 23.878 26.885 23.5712 26.8501 23.2226Z'
        fill='#FAD7B4'
      />
      <path
        d='M26.376 18.6492C26.3133 18.5725 26.2018 18.5586 26.1181 18.6144C26.0414 18.6771 26.0275 18.7887 26.0832 18.8723C26.146 18.949 26.2575 18.963 26.3412 18.9072C26.4249 18.8444 26.4388 18.7329 26.376 18.6492Z'
        fill='#FBEEE2'
      />
      <path
        d='M25.414 17.4919C25.3373 17.3874 25.1909 17.3734 25.0863 17.4501C24.9818 17.5268 24.9678 17.6732 25.0445 17.7778C25.1212 17.8823 25.2676 17.8963 25.3722 17.8196C25.4768 17.7359 25.4977 17.5895 25.414 17.4919Z'
        fill='#FBEEE2'
      />
      <path
        d='M24.4101 17.0945C24.3334 16.99 24.187 16.976 24.0824 17.0527C23.9778 17.1294 23.9639 17.2758 24.0405 17.3804C24.1172 17.4849 24.2636 17.4989 24.3682 17.4222C24.4728 17.3385 24.4937 17.1921 24.4101 17.0945Z'
        fill='#FBEEE2'
      />
      <path
        d='M23.5944 17.9382C23.5177 17.8336 23.3713 17.8196 23.2667 17.8963C23.1621 17.973 23.1482 18.1194 23.2249 18.224C23.3016 18.3286 23.448 18.3425 23.5525 18.2658C23.6571 18.1891 23.6711 18.0427 23.5944 17.9382Z'
        fill='#FBEEE2'
      />
      <path
        d='M22.6602 20.6292C22.5765 20.5246 22.4231 20.5037 22.3185 20.5874C22.2976 20.6571 22.2976 20.7338 22.3185 20.8105C22.3185 20.8105 22.3464 20.8872 22.3813 21.0196C22.458 21.0475 22.5486 21.0336 22.6114 20.9778C22.7299 20.8941 22.7438 20.7408 22.6602 20.6292Z'
        fill='#FBEEE2'
      />
      <path
        d='M10.5016 31.8745C10.7247 26.7991 11.1639 22.8949 11.1639 22.8949L8.98872 22.6858C8.98872 22.6858 8.42402 26.088 8.11029 31.1843C8.8214 31.5747 9.69286 31.749 10.5016 31.8745Z'
        fill='#ED6F3D'
      />
      <path
        d='M8.6262 21.0893L8.75169 18.8584C8.75169 18.8514 8.75169 18.8375 8.75169 18.8305L8.96084 16.6275C8.97478 16.4532 9.13513 16.3207 9.3164 16.3347C9.49766 16.3486 9.63012 16.509 9.60921 16.6902L9.5604 18.1752H9.56738L9.91596 15.4423C9.93687 15.2471 10.1112 15.1007 10.3064 15.1216H10.3133C10.5086 15.1425 10.648 15.3168 10.634 15.512L10.5086 18.21H10.5225L10.9129 15.0588C10.9338 14.8636 11.1011 14.7242 11.2964 14.7451C11.4846 14.766 11.631 14.9334 11.6101 15.1286L11.4009 18.2449H11.4288L11.7356 15.9024C11.7565 15.7072 11.9308 15.5678 12.126 15.5817H12.1399C12.3351 15.6026 12.4746 15.7769 12.4606 15.9721L12.1608 19.1582L12.1399 19.4022L12.133 19.4928L12.4955 18.4401C12.5582 18.2519 12.7604 18.1543 12.9486 18.224H12.9556C13.0672 18.2588 13.1438 18.3495 13.1787 18.4541C13.1996 18.5238 13.1996 18.6005 13.1787 18.6771C13.1787 18.6771 13.1508 18.7538 13.116 18.8863C12.9486 19.4092 12.5094 20.7547 12.3351 21.1312C12.112 21.5983 11.7356 22.2048 11.2685 22.0724L11.2754 22.0584H11.2685V22.0724L11.1918 22.888L9.01661 22.6789L9.0933 21.8423C8.75169 21.7517 8.59134 21.4379 8.6262 21.0893Z'
        fill='#FAD7B4'
      />
      <path
        d='M9.10027 16.5229C9.16302 16.4462 9.27456 16.4323 9.35822 16.488C9.43491 16.5508 9.44886 16.6623 9.39308 16.746C9.33034 16.8227 9.21879 16.8366 9.13513 16.7808C9.05147 16.7181 9.03753 16.5996 9.10027 16.5229Z'
        fill='#FBEEE2'
      />
      <path
        d='M10.0624 15.3586C10.1391 15.2541 10.2855 15.2401 10.39 15.3168C10.4946 15.3935 10.5086 15.5399 10.4319 15.6445C10.3552 15.749 10.2088 15.763 10.1042 15.6863C9.99962 15.6096 9.9787 15.4632 10.0624 15.3586Z'
        fill='#FBEEE2'
      />
      <path
        d='M11.0663 14.9612C11.143 14.8567 11.2894 14.8427 11.3939 14.9194C11.4985 14.9961 11.5125 15.1425 11.4358 15.2471C11.3591 15.3516 11.2127 15.3656 11.1081 15.2889C11.0035 15.2122 10.9826 15.0658 11.0663 14.9612Z'
        fill='#FBEEE2'
      />
      <path
        d='M11.8819 15.8118C11.9586 15.7072 12.105 15.6932 12.2096 15.7699C12.3142 15.8466 12.3281 15.993 12.2514 16.0976C12.1747 16.2022 12.0283 16.2161 11.9238 16.1394C11.8262 16.0558 11.8052 15.9094 11.8819 15.8118Z'
        fill='#FBEEE2'
      />
      <path
        d='M12.8161 18.5028C12.8998 18.3982 13.0532 18.3773 13.1578 18.461C13.1787 18.5307 13.1787 18.6074 13.1578 18.6841C13.1578 18.6841 13.1299 18.7608 13.095 18.8932C13.0183 18.9211 12.9277 18.9072 12.8649 18.8514C12.7534 18.7677 12.7325 18.6144 12.8161 18.5028Z'
        fill='#FBEEE2'
      />
    </g>
    <defs>
      <clipPath id='clip0_1081_251'>
        <rect
          width='30.5359'
          height='32'
          fill='white'
          transform='translate(0.246216)'
        />
      </clipPath>
    </defs>
  </svg>
)

export default TIC
